import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SessionService } from './session.service';

@Injectable()
export class CBSAService {

    constructor(private http: HttpClient, private sessionService: SessionService) { }

    public getRedirectURL(applicationCode: string) {
        const token = this.sessionService.token;

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token || ''
        };

        const uri: string = environment.uriTTPEndpoint + environment.apiVersion + 'goesapp/cbsa/redirect-url?' +
            'applicationCode=' + applicationCode;

        return  this.http.get(uri, {headers}).pipe(
            map((res: any) => {
            return res.url;
        }),
        catchError(error => this.handleError(error)));
    }

    private handleError(error: any) {
        //console.log('Errorr : ' + error);

        // Don't really need to formulate an error message here
        return observableThrowError(error);
    }
}
